import React from 'react';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconBaseProps, IconRender } from '../types.ts';

const Minus = React.forwardRef<SVGSVGElement | null, IconBaseProps>(function Minus({ dataTestId, ...props }, ref) {
  const iconRender = useCallbackRef<IconRender>((color: string) => (
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M22 12.25C22 12.5261 21.7761 12.75 21.5 12.75H2.5C2.22386 12.75 2 12.5261 2 12.25V11.75C2 11.4739 2.22386 11.25 2.5 11.25H21.5C21.7761 11.25 22 11.4739 22 11.75V12.25Z'
      fill={color}
    />
  ));
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'minus-icon-svg'} iconRender={iconRender} {...props} />;
});

export default Minus;
